import { inject, Injectable, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { LoadingService } from './loading.service';
import {Auth, GoogleAuthProvider, signInWithPopup, signOut, User, authState} from '@angular/fire/auth'
import { Firestore, doc, docData, updateDoc, arrayRemove, setDoc, serverTimestamp, collection, CollectionReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserProfile } from '../model/iuser-profile';
import { LoadingService } from './loading.service';
import { Invitation } from '../model/iinvitation';
import {LogLevel, setLogLevel} from "@angular/fire"

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  userRef: CollectionReference;
  userProfile?: UserProfile;
  userProfile$? : Observable<any>
  authState$: Observable <User| null>;
  private readonly LAST_URL_KEY = 'workplace';
  constructor(
    private route: ActivatedRoute,
    public loadingService: LoadingService,
    public router: Router, 
    public auth:Auth,
    private firestore: Firestore,
    private ngZone: NgZone

  ) { 
    setLogLevel(LogLevel.SILENT);
    this.userRef = collection(this.firestore, 'userProfile');
    this.authState$ = authState(this.auth);
  }

  async googleLogin():Promise<any>{ 
    let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/dashboard';
    
    localStorage.setItem('returnUrl', returnUrl);
    localStorage.setItem('awaitRedirect', "true");
  
    const googleAuthProvider = new GoogleAuthProvider();
    googleAuthProvider.setCustomParameters({
      prompt : 'select_account'
    })
    return this.ngZone.run(()=>signInWithPopup(this.auth, googleAuthProvider));
    
  }


  getUserProfile(uid:string):Observable<UserProfile|null>{
    const userDocRef = doc(this.firestore, `userProfile/${uid}`);
    return docData(userDocRef).pipe(
      map(data => data? {...(data as UserProfile), uid} : null)
    );
  }

  // getCurrentProfile(uid : string) : Observable<any>{
  //   const userDocRef = doc(this.firestore, `userProfile/${uid}`);
  //   return docData(userDocRef).pipe(
  //     map(profile => ({
  //       ...(profile as UserProfile),
  //       uid
  //     }))
  //   );
  // }

  async removeInvitation(uid: string, invitation : Invitation): Promise<void>{
    const userDocRef = doc(this.firestore, `userProfile/${uid}`);
    return updateDoc(userDocRef, {
      listInvitation: arrayRemove({
        uid: invitation.uid, 
        displayName: invitation.displayName,
        photoURL: invitation.photoURL,
        workplaceUID: invitation.workplaceUID,
        workplaceName: invitation.workplaceName
      })
    })    
  }

  createAccount(userProfile: UserProfile):Promise<void>{
    const userDocRef = doc(this.firestore, `userProfile/${userProfile.uid}`);
    return setDoc(userDocRef, {
      displayName: userProfile.displayName,
      phoneNumber: userProfile.phoneNumber,
      joinDate: serverTimestamp(),
      photoURL: userProfile.photoURL,
      email: userProfile.email
    })
  }

  async logout(): Promise<void>{
    await signOut(this.auth);
    this.userProfile = undefined;
    localStorage.removeItem('uid');
    
    sessionStorage.removeItem(this.LAST_URL_KEY);
    await this.router.navigate(['/'])
  }

}
